module.exports = __webpack_public_path__ + "img/img14.976d77f0.svg";